export var Language;
(function (Language) {
    Language["SV"] = "SV";
    Language["EN"] = "EN";
})(Language || (Language = {}));
export const PLACEHOLDER = {
    [Language.SV]: "Fylls i senare",
    [Language.EN]: "Filled in at a later stage",
};
